import styled from "@emotion/styled";
import Colors from "styles/colors";
import { BACKGROUND_GRAY_COLOR_NAME } from "styles/color-consts";
import HeaderConstants from "segments/desktop/header/layouts/components/basic-header/constants";
export const StyledTeamsFilters = styled.div`
    .dropdown-menu-button {
        width: 132px;
    }

    .dropdown-menu .dropdown-content {
        width: 898px;
        max-height: calc(100vh - ${HeaderConstants.BASIC_HEADER_HEIGHT}px - 168px);

        .team-item {
            cursor: pointer;
            display: flex;
            flex-direction: row;
            gap: 12px;
            margin-bottom: 40px;
            align-self: stretch;
            padding-right: 15px;
            font-size: 0.875rem;
            line-height: 22px;
            flex-basis: 25%;
            border-radius: 5px;

            &:hover, &.is-active {
                background-color: ${Colors[BACKGROUND_GRAY_COLOR_NAME]};
            }

            .colored-ribbon {
                display: inline-block;
                width: 7px;
                height: auto;
                border-top-left-radius: 2px;
                border-bottom-left-radius: 2px;
            }

            .details {
                display: flex;
                flex-direction: column;
                gap: 4px;
		            padding: 4px 0;

                .team {
                    font-size: 0.875rem;
                    font-weight: 400;
                }

                .description {
                    font-size: 0.75rem;
                    line-height: 1rem;
                }
            }
        }
    }
`;
